import React from 'react'
import { Typography, Button, Grid } from '@mui/material'
import { ChatBubbleOutline } from '@mui/icons-material'

interface MyComponentProps {
  loading: boolean
  onClick: () => void
  loggingMetrics: any
  setLoggingMetrics: any
}

// This is a workaround to enable TTS on iOS devices.
const enableAutoTTS = () => {
  if (typeof window === 'undefined') {
    return
  }
  const isiOS =
    navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
  if (!isiOS) {
    return
  }
  const simulateSpeech = () => {
    const lecture = new SpeechSynthesisUtterance('hello')
    lecture.volume = 0
    speechSynthesis.speak(lecture)
    document.removeEventListener('click', simulateSpeech)
  }

  document.addEventListener('click', simulateSpeech)
}

const BeginChat: React.FC<MyComponentProps> = ({ loading, onClick, loggingMetrics, setLoggingMetrics }) => {
  return (
    <>
      <Typography variant="h6">
      </Typography>
      <Button
        variant="contained"
        startIcon={<ChatBubbleOutline />}
        disabled={loading}
        style={{ backgroundColor: '#F80090' }}
        onClick={() => {
          enableAutoTTS()
          onClick()
          setLoggingMetrics({
            ...loggingMetrics,
            'beginChatCnt':loggingMetrics['beginChatCnt']+1
        })}}
        sx={{ marginTop: '12px' }}
      >
        {loading ? 'Loading...' : 'Start Coffee Chat'}
      </Button>
    </>
  )
}

export default BeginChat
